var _defs, _circle, _circle2, _path, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrown = function SvgCrown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".crown_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 6.333,
    r: 1.5,
    className: "crown_svg__a"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 6.417,
    r: 1.5,
    className: "crown_svg__a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 22h16M4 19 1.953 7.828S3 13 7 13s5-7 5-7 1 7 5 7 5.047-5.093 5.047-5.093L20 19Z",
    className: "crown_svg__a"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 4,
    r: 2,
    className: "crown_svg__a"
  })));
};
export default SvgCrown;